import { Flex, HStack } from "@chakra-ui/react"
import type { ReactNode } from "react"

type WmsListToolbarProps = {
  actions?: ReactNode
  actionsWrap?: "nowrap" | "wrap"
  filters: ReactNode
}

export function WmsListToolbar({
  actions,
  actionsWrap = "wrap",
  filters,
}: WmsListToolbarProps) {
  return (
    <Flex
      direction={{ base: "column", lg: "row" }}
      align={{ base: "stretch", lg: "center" }}
      justify="space-between"
      gap={3}
      mb={4}
    >
      <HStack w="full" spacing={2} align="stretch" flexWrap="wrap">
        {filters}
      </HStack>
      {actions ? (
        <HStack spacing={2} flexWrap={actionsWrap}>
          {actions}
        </HStack>
      ) : null}
    </Flex>
  )
}
